var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-tooltip',{attrs:{"target":_vm.target}},[_c('div',{staticClass:"bold",attrs:{"data-testid":"header-text"}},[_vm._v(_vm._s(_vm.timestampTypeText)+" "+_vm._s(_vm.timestampInWords))]),_vm._v(" "),_c('div',{staticClass:"text-tertiary",attrs:{"data-testid":"body-text"}},[_vm._v(_vm._s(_vm.timestamp))])])
}
var staticRenderFns = []

export { render, staticRenderFns }